import { CartScopeEq } from '@/models/cart/group/scope'
import { Either, Left, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'

import { log } from '@/log'
import { ApiCoupon } from '@/models/api/coupon'
import { ApiService } from '@/services/api/service'
import { ApiClient } from './client'

const namespace: string = 'coupon'

export interface Query {
  only?: string[]
  only_usable?: boolean
  start?: number
  limit?: number
}
const parseQuery = (q: Query) => {
  const only = (q.only ? { only: q.only.join(',') } : {})

  return {
    ...q,
    ...only,
  }
}

interface QueryKey {
  host: string
}
export const queryKey: Readonly<QueryKey> = {
  host: 'host',
}

export default class CouponService extends ApiService {
  static create(): CouponService {
    return new this('/api/user/coupon')
  }
  static createWithScope(scope: CartScopeEq): CouponService {
    return new this(`/api/user/coupon/${scope.kind.toString()}/${scope.value.toString()}`)
  }

  private constructor(private readonly listUrl: string) {
    super()
  }

  /**
   * Fetch coupons under both mycolor and brand scope.
   */
  async list(query: Query): Promise<Either<Error, ApiCoupon[]>> {
    try {
      const response = await ApiClient
        .get(this.listUrl)
        .query(parseQuery(query))

      log.debug({ service: `${namespace}/get`, response })

      return new Right(
        _.map(response.body.data, (rawCoupon: any) => new ApiCoupon(rawCoupon))
      )
    } catch (error) {
      log.error({ service: `${namespace}/get`, error })

      return new Left(error)
    }
  }

  /**
   * ホスト共通クーポンのみ取得する
   */
  async commonListWithRange(
    start: number,
    limit: number
  ): Promise<Either<Error, ApiCoupon[]>> {
    return this.list({
      start,
      limit,
      only: [queryKey.host],
    })
  }

  /**
   * ブランド固有クーポンのみ取得する
   */
  async brandListWithRange(
    brandEnglishName: string,
    start: number,
    limit: number
  ): Promise<Either<Error, ApiCoupon[]>> {
    return this.list({
      start,
      limit,
      only: [brandEnglishName],
    })
  }
}
